import { useEffect, useState } from 'react';
import { FirestoreQuestionProvider } from '../data/FirestoreQuestionProvider';
import { QuestionConfig, QuestionSetConfig } from '../types/GameplayTypes';

/** A question set can only be played if it is active and contains at least one question. */
export function isQuestionSetPlayable(questionSet: QuestionSetConfig | undefined): boolean {
	return Boolean(questionSet?.isActive && !questionSet.questionIds.empty());
}

/** Load questions for a QuestionSet from the database */
export function useQuestionSetQuestions(questionSet: QuestionSetConfig | undefined): QuestionConfig[] | undefined {
	const [questions, setQuestions] = useState<QuestionConfig[] | undefined>();

	useEffect(() => {
		async function loadQuestions() {
			if (questionSet) {
				// Load questions into game state
				const provider = new FirestoreQuestionProvider();
				const loadedQuestionSet = await provider.questions(questionSet.id);
				setQuestions(loadedQuestionSet.questions);
			} else {
				setQuestions(undefined);
			}
		};
		void loadQuestions();
	}, [questionSet?.id]);

	return questions;
}